import { GeoLocation } from '@grid-ui/common';
import { ItemInformationListingItemDatatype } from '../item-information-listing';

export function isGeoLocation(data: ItemInformationListingItemDatatype): data is GeoLocation {
  return (data as GeoLocation).geo_id !== undefined && (data as GeoLocation).type === 'site';
}
